import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import ShopLayout from '../components/shop/ShopLayout';
import ProductCard from '../components/shop/ProductCard';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import api from '../services/api';
import { mapApiProductToCard } from '../utils/shopHelpers';
import './WishlistPage.css';
import Seo from '../components/seo/Seo';

function WishlistPage() {
  const navigate = useNavigate();
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { refresh: refreshWishlistIds } = useWishlist();
  const { addItem } = useCart();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) return;
    (async () => {
      try {
        const res = await api.getWishlist();
        setItems(Array.isArray(res?.data) ? res.data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [isAuthenticated]);

  const handleRemove = async (productId) => {
    await api.removeFromWishlist(productId);
    setItems((prev) => prev.filter((i) => i.id !== productId));
    refreshWishlistIds();
  };

  const handleMoveToCart = (product) => {
    addItem(mapApiProductToCard(product), 1);
    navigate('/cart');
  };

  if (authLoading) {
    return (
      <ShopLayout breadcrumbs={[{ label: 'Wishlist' }]}>
        <Seo title="Wishlist" path="/wishlist" />
        <div className="container wishlist-page"><p>Loading…</p></div>
      </ShopLayout>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: { pathname: '/wishlist' } }} replace />;
  }

  return (
    <ShopLayout breadcrumbs={[{ label: 'Wishlist' }]}>
      <Seo title="Wishlist" path="/wishlist" />
      <div className="container wishlist-page">
        <h1>My Wishlist</h1>
        {loading && <p>Loading wishlist…</p>}
        {!loading && items.length === 0 && (
          <div className="wishlist-page__empty">
            <p>Your wishlist is empty.</p>
            <Link to="/shop">Browse products</Link>
          </div>
        )}
        <div className="wishlist-page__grid">
          {items.map((item) => {
            const card = mapApiProductToCard(item);
            return (
              <div key={item.id} className="wishlist-page__item">
                <ProductCard product={card} />
                <div className="wishlist-page__actions">
                  <button type="button" onClick={() => handleMoveToCart(item)} disabled={!card.inStock}>
                    Move to Cart
                  </button>
                  <button type="button" className="remove" onClick={() => handleRemove(item.id)}>
                    Remove
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </ShopLayout>
  );
}

export default WishlistPage;
